
  import { composeConfigs, PreviewWeb, ClientApi } from '@storybook/preview-api';

  // generateAddonSetupCode
  import { createBrowserChannel } from '@storybook/channels';
  import { addons } from '@storybook/preview-api';

  const channel = createBrowserChannel({ page: 'preview' });
  addons.setChannel(channel);
  window.__STORYBOOK_ADDONS_CHANNEL__ = channel;

  const importers = {
      ...import("story:Li4vLi4vLi4vcGFja2FnZXMvQHtyZWFjdC1hcmlhLHJlYWN0LXN0YXRlbHksc3BlY3RydW0taWNvbnN9Lyovc3Rvcmllcy8qLnN0b3JpZXMue2pzLGpzeCx0cyx0c3h9"),
...import("story:Li4vLi4vLi4vcGFja2FnZXMvQHJlYWN0LXNwZWN0cnVtLyEoczIpL3N0b3JpZXMvKi5zdG9yaWVzLntqcyxqc3gsdHMsdHN4fQ=="),
...import("story:Li4vLi4vLi4vcGFja2FnZXMvcmVhY3QtYXJpYS1jb21wb25lbnRzL3N0b3JpZXMvKi5zdG9yaWVzLntqcyxqc3gsdHMsdHN4fQ==")
    };

    async function importFn(path) {
      return importers[path]();
    }

  const getProjectAnnotations = async () => {
    const configs = await Promise.all([import('@storybook/react/dist/entry-preview.mjs'),
import('@storybook/addon-actions/preview'),
import('@storybook/addon-a11y/preview'),
import('../../../.storybook/preview.js')])
    return composeConfigs(configs);
  }

  if (!window.__STORYBOOK_PREVIEW__) {
    const preview = new PreviewWeb();

    window.__STORYBOOK_PREVIEW__ = preview;
    window.__STORYBOOK_STORY_STORE__ = preview.storyStore;
    window.__STORYBOOK_CLIENT_API__ = new ClientApi({ storyStore: preview.storyStore });

    preview.initialize({ importFn, getProjectAnnotations });
  }

  module.hot.accept(() => {
    // importFn has changed so we need to patch the new one in
    window.__STORYBOOK_PREVIEW__.onStoriesChanged({ importFn });

    // getProjectAnnotations has changed so we need to patch the new one in
    window.__STORYBOOK_PREVIEW__.onGetProjectAnnotationsChanged({ getProjectAnnotations });
  });
 